import axios from 'axios'
import { delay } from '../../_augmentt/utils/utils'
import { TASK_ACTIONS, TASK_TYPES } from '../util/hub-task-management/hub.constants'
import { createHubTask, pollTaskStatus } from './integrationHub.crud'

const ROOT = process.env.REACT_APP_AUGMENTT_API_URL

export const CUSTOMERS_URL = `${ROOT}/customer`

export function getCustomerLicenses({ customerId }) {
  return axios.get(`${CUSTOMERS_URL}/${customerId}/licenses`)
}

export const syncCustomerLicenses = async ({ customerId, organizationId, userId }) => {
  const params = {
    tasktype: TASK_TYPES.subscriptions,
    action: TASK_ACTIONS.get,
    customerId,
    organizationId,
    userId,
  }

  const taskResponse = await createHubTask(params)
  const { taskId } = taskResponse.data

  // wait 4 seconds before checking the backend so the task can be created
  await delay(4 * 1000)

  const pollTask = await pollTaskStatus(taskId, {
    retries: 180,
    timeout: 5000,
  })

  const pollTaskData = JSON.parse(JSON.stringify(pollTask.data))

  // eslint-disable-next-line no-underscore-dangle
  if (pollTaskData._source.status === 'FAILED') {
    throw new Error('Failed to sync customer licenses')
  }

  // wait 1 seconds so data can be updated in elastic
  await delay(1000)
}
